import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import {
  PostV2AuthLoginBody,
  PostV2AuthLoginResponse,
  useAvApi,
} from '@app-velocity/av-api-v2';

export const useAuthenticateMutation = () => {
  const { auth } = useAvApi();
  const queryClient = useQueryClient();

  return useMutation<PostV2AuthLoginResponse, AxiosError, PostV2AuthLoginBody>({
    mutationKey: ['users', 'login'],
    mutationFn: async (userLoginDto) => {
      const { data } = await auth.postV2AuthLogin(
        {
          password: userLoginDto.password,
          email: userLoginDto.email,
        },
        {}
      );

      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['current-user'] });
    },
  });
};
